import { render, staticRenderFns } from "./RecusadaComponent.vue?vue&type=template&id=b0873254&scoped=true"
import script from "./RecusadaComponent.vue?vue&type=script&lang=js"
export * from "./RecusadaComponent.vue?vue&type=script&lang=js"
import style0 from "./RecusadaComponent.vue?vue&type=style&index=0&id=b0873254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0873254",
  null
  
)

export default component.exports